import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>SecureGuard Systems</h3>
            <p>Your trusted partner for comprehensive security solutions. We protect homes, businesses, and institutions with advanced security systems and 24/7 monitoring services.</p>
          </div>
          <div className="footer-section">
            <h3>Services</h3>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li><Link to="/services">Residential Security</Link></li>
              <li><Link to="/services">Commercial Security</Link></li>
              <li><Link to="/services">CCTV Installation</Link></li>
              <li><Link to="/services">Alarm Systems</Link></li>
              <li><Link to="/services">Access Control</Link></li>
              <li><Link to="/services">24/7 Monitoring</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Industries</h3>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li>Homes & Apartments</li>
              <li>Offices & Commercial</li>
              <li>Warehouses & Industrial</li>
              <li>Retail Stores</li>
              <li>Schools & Institutions</li>
              <li>Hospitals</li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Contact</h3>
            <p>info@secureguard.com</p>
            <p>+1 (555) 123-4567</p>
            <p>Emergency: +1 (555) 911-0000</p>
            <p>123 Security Drive<br />Safety City, SC 12345</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 SecureGuard Systems. All rights reserved. | Licensed & Insured</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 